(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-search-v2"] && !Shopify.designMode) return;
  try {
    class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';
    this.resourceTypes = this.dataset.resourceTypes;
    this.errorMessage = 'Error fetching suggestions. Please try again.';

    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.querySelector('form');
    form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.input.addEventListener('input', this.debounce((event) => { this.onChange(event); }, 300).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector('#search-bar-results-groups-wrapper')?.remove();
    }
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);
    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"]')) event.preventDefault();
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();
    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
      case 'Escape':
        this.close();
        break;
    }
  }

  onKeydown(event) {
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    if (searchForTextElement) {
      const currentButtonText = searchForTextElement.innerText;
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allVisibleElements = Array.from(this.querySelectorAll('.search-bar__result-item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
    activeElement.scrollIntoView({ block: 'nearest' });
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');
    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    this.abortController.abort();
    this.abortController = new AbortController();
    const signal = this.abortController.signal;

    const params = new URLSearchParams();
    params.append('q', encodeURIComponent(searchTerm));
    params.append('resources[type]', this.resourceTypes);
    params.append('resources[limit]', '10');
    params.append('resources[limit_scope]', 'each');
    params.append('section_id', 'predictive-search');

    fetch(`${routes.predictive_search_url}?${params.toString()}`, { signal })
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        this.renderErrorMessage();
        this.close();
        console.error(error);
      });
  }

  renderErrorMessage() {
    this.predictiveSearchResults.innerHTML = `<p class="predictive-search__error">${this.errorMessage}</p>`;
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.querySelector('.predictive-search-status');
    this.loadingText = this.dataset.loadingText;

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;
    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);
    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  open() {
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');
    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.removeAttribute('loading');
    this.input.setAttribute('aria-expanded', false);
    this.isOpen = false;
  }
}

customElements.define('predictive-search', PredictiveSearch);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-search"] && !Shopify.designMode) return;
  try {
    (() => {
    const wrappers = document.querySelectorAll('[data-search-bar]');

    if (!wrappers.length) return;

    const debounce = (fn, delay) => {
      let timeoutId;
      return (...args) => {
        if (timeoutId) window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => fn(...args), delay);
      };
    };

    const buildSuggestUrl = (query) => {
      const params = new URLSearchParams();
      params.set('q', query);
      params.set('resources[type]', 'product,collection,article');
      params.set('resources[options][fields]', 'title,product_type,variants.title,vendor');
      return `/search/suggest.json?${params.toString()}`;
    };

    const createGroupHeading = (label) => {
      const heading = document.createElement('div');
      heading.className = 'predictive__search__group-title';
      heading.textContent = label;
      return heading;
    };

    const createResultItem = (item, type, indexOffset) => {
      const option = document.createElement('a');
      option.className = 'search-bar__result-item';
      option.href = item.url;
      option.setAttribute('role', 'option');
      option.setAttribute('data-index', String(indexOffset));
      option.setAttribute('aria-selected', 'false');

      const textWrapper = document.createElement('div');

      const titleEl = document.createElement('div');
      titleEl.className = 'search-bar__result-title';
      titleEl.textContent = item.title || '';

      const metaEl = document.createElement('div');
      metaEl.className = 'search-bar__result-meta';
      metaEl.textContent = type.charAt(0).toUpperCase() + type.slice(1);
      console.log("Item", item);
// Provided you Items
// {
//     "id": 651366072452,
//     "body": "",
//     "handle": "incense",
//     "published_at": "2026-01-14T08:44:32.000Z",
//     "title": "Incense",
//     "url": "/collections/incense?_pos=1&_psq=in&_ss=e&_v=1.0",
//     "featured_image": {
//         "alt": null,
//         "aspect_ratio": null,
//         "height": null,
//         "url": null,
//         "width": null
//     }
// }
// {
//     "available": true,
//     "body": "",
//     "compare_at_price_max": "0.00",
//     "compare_at_price_min": "0.00",
//     "handle": "incense-sagrado-kundalini",
//     "id": 10213057659012,
//     "image": null,
//     "price": "10.30",
//     "price_max": "10.30",
//     "price_min": "10.30",
//     "tags": [],
//     "title": "Incense Sagrado Kundalini",
//     "type": "",
//     "url": "/products/incense-sagrado-kundalini?_pos=5&_psq=in&_ss=e&_v=1.0",
//     "variants": [],
//     "vendor": "Sagradamarde",
//     "featured_image": {
//         "alt": null,
//         "aspect_ratio": null,
//         "height": null,
//         "url": null,
//         "width": null
//     }
// }

      textWrapper.appendChild(titleEl);
      textWrapper.appendChild(metaEl);

      option.appendChild(textWrapper);

      return option;
    };

    const renderResults = (resultsRoot, data, query) => {
      const categoriesContainer = resultsRoot.querySelector('.predictive__search__categories');
      const productsContainer = resultsRoot.querySelector('.predictive__search__products');
      const articlesContainer = resultsRoot.querySelector('.predictive__search__articles');

      // Clear previous content
      [categoriesContainer, productsContainer, articlesContainer].forEach((container) => {
        if (container) {
          container.innerHTML = '';
          container.classList.remove('predictive__search__group--hidden');
        }
      });

      if (!data || !query || !query.trim()) {
        resultsRoot.hidden = true;
        return;
      }

      // Predictive search: resources.results.{products,collections,articles}
      const resourcesRoot = data.resources && data.resources.results
        ? data.resources.results
        : {};

      const products = resourcesRoot.products || [];
      const collections = resourcesRoot.collections || [];
      const articles = resourcesRoot.articles || [];

      // Nothing? Hide the root container.
      if (!products.length && !collections.length && !articles.length) {
        resultsRoot.hidden = true;
        return;
      }

      let globalIndex = 0;

      // Categories (collections)
      if (categoriesContainer && collections.length) {
        categoriesContainer.appendChild(createGroupHeading('Categories'));

        collections.forEach((item) => {
          const option = createResultItem(item, 'collection', globalIndex);
          categoriesContainer.appendChild(option);
          globalIndex += 1;
        });
      } else if (categoriesContainer) {
        categoriesContainer.classList.add('predictive__search__group--hidden');
      }

      // Products
      if (productsContainer && products.length) {
        productsContainer.appendChild(createGroupHeading('Products'));

        products.forEach((item) => {
          const option = createResultItem(item, 'product', globalIndex);
          productsContainer.appendChild(option);
          globalIndex += 1;
        });
      } else if (productsContainer) {
        productsContainer.classList.add('predictive__search__group--hidden');
      }

      // Articles
      if (articlesContainer && articles.length) {
        articlesContainer.appendChild(createGroupHeading('Articles'));

        articles.forEach((item) => {
          const option = createResultItem(item, 'article', globalIndex);
          articlesContainer.appendChild(option);
          globalIndex += 1;
        });
      } else if (articlesContainer) {
        articlesContainer.classList.add('predictive__search__group--hidden');
      }

      resultsRoot.hidden = false;
    };

    wrappers.forEach((wrapper) => {
      const form = wrapper.querySelector('form.search-bar');
      const input = wrapper.querySelector('.search-bar__input');
      const resultsRoot = wrapper.querySelector('.search-bar__results');

      if (!form || !input || !resultsRoot) return;

      let activeIndex = -1;

      const getAllOptions = () =>
        resultsRoot.querySelectorAll('.search-bar__result-item[role="option"]');

      const updateActiveDescendant = () => {
        const options = getAllOptions();

        options.forEach((option, index) => {
          const isActive = index === activeIndex;
          option.setAttribute('aria-selected', isActive ? 'true' : 'false');
          if (isActive) {
            option.scrollIntoView({ block: 'nearest' });
          }
        });
      };

      const clearResults = () => {
        const groups = resultsRoot.querySelectorAll(
          '.predictive__search__categories, .predictive__search__products, .predictive__search__articles'
        );
        groups.forEach((group) => {
          group.innerHTML = '';
        });
        resultsRoot.hidden = true;
        activeIndex = -1;
        input.setAttribute('aria-expanded', 'false');
      };

      const handleInput = async () => {
        const query = input.value.trim();

        if (query.length < 2) {
          clearResults();
          return;
        }

        try {
          const response = await fetch(buildSuggestUrl(query), {
            headers: {
              Accept: 'application/json',
            },
          });

          if (!response.ok) {
            clearResults();
            return;
          }

          const data = await response.json();
          renderResults(resultsRoot, data, query);

          const hasResults = !!getAllOptions().length;
          input.setAttribute('aria-expanded', hasResults ? 'true' : 'false');
          activeIndex = hasResults ? 0 : -1;
          updateActiveDescendant();
        } catch (error) {
          clearResults();
        }
      };

      const debouncedInput = debounce(handleInput, 180);

      input.addEventListener('input', () => {
        debouncedInput();
      });

      input.addEventListener('keydown', (event) => {
        const options = getAllOptions();
        const hasOptions = options.length > 0;

        if (!hasOptions) return;

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          activeIndex = Math.min(activeIndex + 1, options.length - 1);
          updateActiveDescendant();
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          activeIndex = Math.max(activeIndex - 1, 0);
          updateActiveDescendant();
        } else if (event.key === 'Enter') {
          if (activeIndex >= 0 && activeIndex < options.length) {
            event.preventDefault();
            const target = options[activeIndex];
            if (target && typeof target.click === 'function') {
              target.click();
            }
          }
        } else if (event.key === 'Escape') {
          clearResults();
        }
      });

      document.addEventListener('click', (event) => {
        if (!wrapper.contains(event.target)) {
          clearResults();
        }
      });

      form.addEventListener('submit', () => {
        clearResults();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
